<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12t7r5v/images/Cover.jpg?1708005252061" alt="This image is the cover for the book Ghosts and Legends of Lafayette and Louisville, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghosts and Legends of Lafayette and Louisville, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>Explore ghastly history and lasting lore!   The legend of local miner Teodor Glava, the Lafayette Vampire, has reached near cult status, with people from all over the country visiting his gravesite. Buried bootleggers lost to an underground tunnel explosion purportedly haunt Louisville's Main Street. Local teenagers explore the outskirts of Old Town Lafayette to confront the legendary La Llorona, who preyed on curious children and adults. And, an infamous Headless Horseman stalks Spruce Lane, a dirt road in old town Louisville. Sorting out fact from fiction with some tantalizing first-hand accounts, author Doug Conarroe takes a critical look at these and other myths, legends and ghost tales.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Doug Conarroe
      </h2>
      
      <p class="authorDescription body article">Doug Conarroe is a fourth-generation Coloradan and Louisville native. His parents owned and operated the Louisville Times , Lafayette News and Erie Review from 1965 to 1997. He was their editor in the 1990s, later joining the Denver Post . With a journalism degree and an MBA from the University of Colorado, he published the North Forty News from 2011 to 2017. His previous books include 80026: An Illustrated History of Lafayette , Colorado and Lost Lafayette, Colorado . Doug's local history blog can be found at lafayettehistory.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd899942